/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const RenameGroupGroupDataParser = 
/* #__PURE__ */ parsers.object([['name', codecString]]);
export class RenameGroupGroupData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RenameGroupGroupDataParser.decode(input).map(res => new RenameGroupGroupData(res));
    }
    static unsafeDecode(input) {
        return RenameGroupGroupData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RenameGroupGroupDataParser.encode(data);
    }
    static schema() {
        return RenameGroupGroupDataParser.schema();
    }
}
